// The file types each upload accepts; the API checks the same lists against the file content.
// image/jpeg comes first in every list: Safari converts a photo the list does not allow into the first listed type.
// image/heic must never be listed, since Safari then converts JPEG and PNG picks into HEIC.

export const AdvertImageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

// The accept value of the advert image pickers, which only steers the browser's picker; the types are checked after resizing.
// It is the legacy media capture syntax and possibly keeps the camera option in Chrome on Android, which an
// image-only accept list loses. Replace it with AdvertImageTypes only after testing camera capture on Android and iOS.
export const AdvertImageAccept = 'image/*;capture=camera';

export const LogoTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

export const DocumentTypes = ['application/pdf'];

export const VerificationDocumentTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];

export const isAcceptedType = (file: Blob | undefined, types: string[]) => !!file && types.includes(file.type);
